// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

/**
 * Retrieve the shipping accounts list.
 */
export function useShippingAccounts(query = {}, props?) {
  const params = new URLSearchParams();
  if (query.carrier_id) params.append('carrier_id', query.carrier_id);
  if (query.customer_id) params.append('customer_id', query.customer_id);
  if (query.status) params.append('status', query.status);
  const queryStr = params.toString() ? `?${params.toString()}` : '';

  return useRequestQuery(
    [t.SHIPPING_ACCOUNTS, query],
    { method: 'get', url: `shipping-accounts${queryStr}` },
    {
      select: (res) => res.data.shipping_accounts ?? res.data.shippingAccounts,
      defaultData: [],
      ...props,
    },
  );
}

/**
 * Retrieve a single shipping account by ID.
 */
export function useShippingAccount(id, props?) {
  return useRequestQuery(
    [t.SHIPPING_ACCOUNT, id],
    { method: 'get', url: `shipping-accounts/${id}` },
    {
      select: (res) =>
        res.data.shipping_account ?? res.data.shippingAccount,
      defaultData: {},
      enabled: !!id,
      ...props,
    },
  );
}

/**
 * Create a shipping account.
 */
export function useCreateShippingAccount(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (values) => apiRequest.post('shipping-accounts', values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIPPING_ACCOUNTS);
      },
      ...props,
    },
  );
}

/**
 * Edit a shipping account.
 */
export function useEditShippingAccount(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([id, values]) => apiRequest.post(`shipping-accounts/${id}`, values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIPPING_ACCOUNTS);
        queryClient.invalidateQueries(t.SHIPPING_ACCOUNT);
      },
      ...props,
    },
  );
}

/**
 * Delete a shipping account.
 */
export function useDeleteShippingAccount(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (id) => apiRequest.delete(`shipping-accounts/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIPPING_ACCOUNTS);
      },
      ...props,
    },
  );
}
